import { trackEvent } from 'ddc-track-event';
/**
 * Prevents event, sets the start value, triggers a tracking event and scrolls
 * the user to the top of the page.
 * @param {object} e An event object
 * @param {number} start A number defining the next start value to be set
 * @param {string} type A string representing the type of paging button
 * @param {string} widgetName A string for widgetName
 * @param {string} windowId A string for windowId
 * @param {number} pageNumber (optional) A number to represent specific page
 */
export const getPage = (e, start, type, widgetName, windowId, pageNumber) => {
	e.preventDefault();
	window.DDC.InvData.setStart(start);
	trackEvent(widgetName, windowId, {
		element: `Pagination ${type} button`,
		elementCTA: type === 'specific' ? pageNumber : undefined,
		result: `Navigated to ${type} page`
	});
	window.DDC.scrollToAnchor($('[data-widget-id="inventory-results1"]'), {
		heightAdj: $('.page-header').height()
	});
};

/**
 * return true if paging.pageStart is 0.
 * @param paging
 * @returns {boolean}
 */
export const isFirstPage = (paging) => {
	return paging ? paging?.pageStart === 0 : false;
};

/**
 * return true if paging is needed.
 * Paging isn't needed if there is no inventory (paging.totalCount === 0)
 * or if the inventory count is less than the number of inventory that shows on a single page
 *
 * @param paging
 * @returns {boolean}
 */
export const isPagingNeeded = (paging) => {
	return (
		paging &&
		paging.totalCount !== 0 &&
		paging.totalCount >= paging.pageSize
	);
};
